export default __webpack_public_path__ + "static/media/ancee.0b493729.png";